/**
 * WF-Skip-Btn - Skip step text link for wizard forms
 *
 * Advances to the next step without validation, or submits on the last step.
 * Renders as an underlined text link, not a button.
 *
 * @example
 * <wf-step data-step="2">
 *   <wf-next-btn label="Continue"></wf-next-btn>
 *   <wf-skip-btn label="Skip this step"></wf-skip-btn>
 * </wf-step>
 */

import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { wfSkipBtnStyles } from './wf-skip-btn.styles.js';

@customElement('wf-skip-btn')
export class WfSkipBtn extends LitElement {
  static styles = wfSkipBtnStyles;

  @property({ type: String })
  label = 'Skip this step';

  private _handleClick = (): void => {
    this.dispatchEvent(
      new CustomEvent('wf:nav-skip', {
        bubbles: true,
        composed: true,
      })
    );
  };

  render() {
    return html`
      <button
        type="button"
        class="wf-skip-link"
        data-testid="wf-skip-btn"
        @click="${this._handleClick}"
      >
        ${this.label}
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'wf-skip-btn': WfSkipBtn;
  }
}
